export default __webpack_public_path__ + "static/media/Honor's Focus.5a5bbcde.jpg";